import {
  FETCH_ROLE,
  FETCH_ROLE_SUCCESS,
  FETCH_ROLE_ERROR,
  ADD_ROLE,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_ERROR,
  RESET_ADD_ROLE,
  UPDATE_ROLE,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_ERROR,
  DELETE_ROLE,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_ERROR,
} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
  updating: false,
  deleting: false,
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_ROLE: {
      return {...state, error: '', loading: true};
    }
    case ADD_ROLE: {
      return {...state, error: '', updating: true};
    }
    case UPDATE_ROLE: {
      return {...state, error: '', updating: true};
    }
    case DELETE_ROLE: {
      return {...state, error: '', deleting: true};
    }
    case FETCH_ROLE_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case ADD_ROLE_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Thêm dữ liệu thành công!' }};
    }
    case UPDATE_ROLE_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Cập nhật dữ liệu thành công!' }};
    }
    case DELETE_ROLE_SUCCESS: {
      const { id } = action.payload;
      const newData = state.data.filter(item => item.id !== id);
      return {...state, error: '', deleting: false, data: newData, payload: { code: 200, message: 'Xóa dữ liệu thành công!' }};
    }
    case FETCH_ROLE_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case ADD_ROLE_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case UPDATE_ROLE_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case DELETE_ROLE_ERROR: {
      return {...state, deleting: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_ADD_ROLE: {
      return {...state, payload: {}};
    }
    default:
      return state;
  }
}
